const JsonRPC = require('./json_rpc');

const {
  EventEmitter
} = require('events').EventEmitter;

const WebSocket = require('ws');

class JsonRPCServer extends EventEmitter {

  constructor(options) {
    super();
    this._clients = new Set();

    this.wss = new WebSocket.Server(options);

    this.wss.on("listening", () => this.emit("listening"));

    this.wss.on("connection", (socket, request) => {

      const jsonRPC = new JsonRPC();
      jsonRPC.socket = socket;

      this._clients.add(jsonRPC);
      jsonRPC.on('close', () => {
        this._clients.delete(jsonRPC);
      });

      this.emit('connection', jsonRPC, request);
    });

    this.wss.on("error", (error) => {
      try {
        this.emit("error", error)
      } catch (e) {

      }
    });

    this.wss.on('close', () => this.emit('close'));
  }

  close() {
    this.wss.close();
  }
}

module.exports = JsonRPCServer;